import { RosterPageQuery, TimesheetsNewPageQuery, TimesheetsPageQuery } from 'type';
import useRouteQuery, { UseRouteQuery } from './useRouteQuery';

export const useRosterQuery = useRouteQuery as UseRouteQuery<RosterPageQuery>;
export const useTimesheetsNewQuery =
  useRouteQuery as UseRouteQuery<TimesheetsNewPageQuery>;
export const useTimesheetsQuery =
  useRosterQuery as UseRouteQuery<TimesheetsPageQuery>;
